import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Divider,
  Stepper,
  Step,
  StepLabel,
  Button,
  Tooltip,
  Alert,
  Snackbar,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { useForm } from "react-hook-form";
import WarningRoundedIcon from "@mui/icons-material/WarningRounded";
import InputFields from "../Settings/FieldsUi/InputFields";
import Header from "../Settings/AllTemplatePage&Compnent/components/Header";
import { pageScrollStyle } from "../../../styles/styles";
import { useDialog } from "../../DialogContext";
import { useDispatch, useSelector } from "react-redux";
import {
  createCase,
  getCases,
} from "../../../redux/Apps/Lawyerapp/CaseSlice/CaseSlice";
import { backend_api } from "../../../static/server";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import ContactMiniForm from "../Contacts/Contact Forms/ContactMiniForm";
import InviteUserForm from "../../../pages/LawyerPages/TeamMembers/Users Form/InviteUserForm";

const MatterForm = ({ formData, onClose, onSubmitSuccess }) => {
  const dispatch = useDispatch();
  const { token } = useSelector((data) => data.user);
  const { showDialog, closeDialog } = useDialog();
  const [activeSection, setActiveSection] = useState(0);
  // const [isSubmitting, setIsSubmitting] = useState(false);
  const [practiceAreaId, setPracticeAreaId] = useState(
    formData?.practice_area?.id ?? ""
  );
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  // Initialize react-hook-form
  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
    register,
    setValue,
  } = useForm({
    mode: "onBlur",
  });

  const watchBillable = watch("billable");
  const watchBillableMethod = watch("billable_method");
  const watchSetCaseBudget = watch("set_case_budget");

  const isMultiSelect = (fieldName) => {
    const sections =
      formData?.custom_fields?.[0]?.field_data?.createNewMatter?.sections || [];
    for (const sec of sections) {
      const found = sec.fields?.find((f) => f.name === fieldName);
      if (found) return found.pickList?.multiSelect || false;
    }
    return false;
  };
  // const watchClientType = watch("clientType");
  // const watchHasConflictCheck = watch("hasConflictCheck");
  console.log("formData", formData);
  console.log(watchBillable, watchBillableMethod);

  useEffect(() => {
    if (formData?.defaultValues) {
      Object.entries(formData.defaultValues).forEach(([key, value]) => {
        setValue(key, value);
      });
    }
  }, [formData, setValue]);

  const onSubmit = async (data) => {
    // setIsSubmitting(true);
    console.log(formData?.custom_fields[0], data);

    const sections =
      formData?.custom_fields?.[0]?.field_data?.createNewMatter?.sections || [];

    const customFieldsData = sections.map((section) => {
      const sectionLabel = section.name || section.section_name;
      const fieldsWithValue = section.fields
        .filter((f) => f.type !== "section")
        .map((f) => ({
          ...f,
          value: data[f.name],
        }));
      return { [sectionLabel]: fieldsWithValue };
    });

    const formatedData = {
      ...data,
      bill_case_contacts: Array.isArray(data?.bill_case_contacts)
        ? data.bill_case_contacts.map((c) =>
            typeof c === "object" ? c.value || c.id : Number(c)
          )
        : isMultiSelect("bill_case_contacts")
        ? []
        : [Number(data?.bill_case_contacts)],
      open_date: data?.open_date
        ? dayjs(data.open_date.$d).format("YYYY-MM-DD")
        : null,
      case_status: data?.case_status,
      practice_area: practiceAreaId,
      link_template: formData?.id,
      custom_fields: [formData?.custom_fields[0]?.id],
      custom_fields_data: customFieldsData,
    };

    try {
      await dispatch(
        createCase({
          url: `${backend_api}case/register/`,
          body: formatedData,
          token: token,
        })
      ).unwrap();
      toast.success("Matter created successfully!");
      closeDialog();
    } catch (err) {
      toast.error("Failed to create matter");
    } finally {
      reset();
      dispatch(getCases({ url: `${backend_api}case/register/`, token: token }));
    }
  };

  // Handle submission error
  const onError = (errors) => {
    console.error("Form validation errors:", errors);
    setNotification({
      open: true,
      message: "Please correct the errors in the form",
      severity: "error",
    });

    const formSections = formData?.sections || [];
    for (let i = 0; i < formSections.length; i++) {
      const section = formSections[i];
      const hasError = section.fields.some((field) => {
        const fieldId = field.id || field.name;
        return errors[fieldId];
      });

      if (hasError) {
        setActiveSection(i);
        handleSectionClick(i);
        break;
      }
    }
  };

  const DotStepIcon = ({ active, completed }) => {
    return (
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: completed || active ? "primary.light" : "#c4c4c4",
        }}
      />
    );
  };

  const getFieldWidth = (sectionColumns) => {
    switch (sectionColumns) {
      case 1:
        return "100%";
      case 2:
        return "calc(50% - 0.5rem)";
      case 3:
      default:
        return "calc(33.33% - 0.67rem)";
    }
  };

  // Handle section navigation
  const handleSectionClick = (sectionIndex) => {
    setActiveSection(sectionIndex);

    const sectionId =
      formSections[sectionIndex]?.section_name?.replace(/\s+/g, "-") ||
      formSections[sectionIndex]?.name?.replace(/\s+/g, "-");

    const sectionElement = document.getElementById(`section-${sectionId}`);
    if (sectionElement) {
      sectionElement.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const shouldRenderField = (field) => {
    if (!field?.conditions || field?.conditions?.length === 0) {
      return true;
    }

    return field.conditions?.every((condition) => {
      const dependentFieldValue = watch(condition.field);

      switch (condition?.operator) {
        case "equals":
          return dependentFieldValue === condition?.value;
        case "notEquals":
          return dependentFieldValue !== condition?.value;
        case "contains":
          return dependentFieldValue?.includes(condition?.value);
        case "greaterThan":
          return dependentFieldValue > condition?.value;
        case "lessThan":
          return dependentFieldValue < condition?.value;
        case "isEmpty":
          return !dependentFieldValue;
        case "isNotEmpty":
          return !!dependentFieldValue;
        case "in":
          return condition?.value.includes(dependentFieldValue);
        default:
          return true;
      }
    });
  };

  const formSections =
    formData?.custom_fields?.[0]?.field_data?.createNewMatter?.sections || [];
  const templateName = formData?.template_name || "";

  if (formSections.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2">No form sections available</Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Header
        tabBtn={1}
        placeType={"MatterForm"}
        templateName={templateName}
        practiceAreaId={practiceAreaId}
        setPracticeAreaId={setPracticeAreaId}
        isReadonly={true}
      />
      <Box
        sx={{
          height: "calc(100vh - 2.8rem)",
          margin: "0 auto",
          display: "flex",
          border: "1px solid #e0e0e0",
          borderRadius: "4px",
          bgcolor: "#ffffff",
          overflow: "hidden",
        }}
      >
        {/* Left Panel */}
        <Box
          sx={{
            width: "22%",
            minWidth: "12rem",
            borderRight: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
            display: "flex",
            flexDirection: "column",
            p: "1rem",
            gap: "0.5rem",
            overflowY: "auto",
          }}
        >
          <Typography variant="body1" fontWeight="bold">
            All Sections
          </Typography>
          <Divider sx={{ mb: 1 }} />
          <Stepper
            orientation="vertical"
            activeStep={activeSection}
            nonLinear={true}
            connector={
              <Box
                sx={{
                  ml: 0.5,
                  height: "1.4rem",
                  borderLeft: "1px dotted #bdbdbd",
                }}
              />
            }
          >
            {formSections?.map((section, index) => (
              <Step key={index} completed={false}>
                <StepLabel
                  StepIconComponent={DotStepIcon}
                  onClick={() => handleSectionClick(index)}
                  sx={{
                    cursor: "pointer",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontSize: "0.9rem",
                      fontWeight: activeSection === index ? 600 : 400,
                      color:
                        activeSection === index ? "primary" : "text.primary",
                      textDecoration:
                        activeSection === index ? "underline" : "none",
                    }}
                  >
                    {section.name || section.section_name}
                  </Typography>
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {/* Right Panel */}
        <Box
          sx={{
            width: "78%",
            height: "100%",
            position: "relative",
            backgroundColor: "#f7f9fc",
            overflowY: "auto",
            ...pageScrollStyle,
          }}
        >
          <form onSubmit={handleSubmit(onSubmit, onError)}>
            <Box
              sx={{
                flexGrow: 1,
                p: "1rem",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "1rem",
                  width: "100%",
                  margin: "0 auto",
                }}
              >
                {formSections?.map((section, i) => {
                  if (!section?.fields || section.fields.length === 0) {
                    return null;
                  }

                  return (
                    <Box key={i}>
                      <Box
                        id={`section-${(
                          section.section_name || section.name
                        ).replace(/\s+/g, "-")}`}
                        sx={{
                          opacity: 1,
                          p: "1rem",
                          borderRadius: "1rem",
                          boxShadow: "0px 0px 0.8rem #d5d5d5",
                          bgcolor: "#fff",
                          cursor: "pointer",
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            p: "0.5rem 1rem",
                          }}
                          onClick={() => handleSectionClick(i)}
                        >
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 600,
                              color: "#333",
                            }}
                          >
                            {section.name || section.section_name}
                          </Typography>
                        </Box>

                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          {section?.fields?.map((field, j) => {
                            if (field.type === "section") return null;
                            let shouldRender = true;

                            if (field?.name === "hourly_rate") {
                              shouldRender =
                                watchBillable &&
                                watchBillableMethod === "hourly";
                            }

                            if (field.name === "flat_rate") {
                              shouldRender =
                                watchBillable &&
                                watchBillableMethod === "flat_rate";
                            }
                            if (field.name === "contingency_rate") {
                              shouldRender =
                                watchBillable &&
                                watchBillableMethod === "contingency";
                            }

                            if (field?.conditions) {
                              shouldRender = shouldRenderField(field);
                            }
                            if (
                              field.name === "budget" ||
                              field.name === "include_expense"
                            ) {
                              shouldRender = watchSetCaseBudget;
                            }

                            const getFieldConfig = (fieldName) => {
                              switch (fieldName) {
                                case "case_related_person":
                                  return {
                                    showAddButton: true,
                                    addButtonText: "Add Contact",
                                    AddFormComponent: ContactMiniForm,
                                    createDialogTitle: "Create New Contact",
                                  };
                                case "case_responsible_attorney":
                                case "case_originating_attorney":
                                  return {
                                    showAddButton: true,
                                    addButtonText: "Add Member",
                                    AddFormComponent: InviteUserForm,
                                    createDialogTitle: "Create New Member",
                                  };
                                // case "company_field": // another example
                                //   return {
                                //     showAddButton: true,
                                //     addButtonText: "Add Company",
                                //     AddFormComponent: ContactMiniForm,
                                //     createDialogTitle: "Create New Company",
                                //   };
                                default:
                                  return {
                                    showAddButton: false,
                                    addButtonText: "Add New",
                                    AddFormComponent: null,
                                    createDialogTitle: "Create New",
                                  };
                              }
                            };
                            const fieldConfig = getFieldConfig(field.name);
                            const displayedField =
                              field.name === "bill_case_contacts"
                                ? { ...field, label: "Select Member(s)" }
                                : field;

                            return shouldRender ? (
                              <Box
                                key={j}
                                sx={{
                                  width: getFieldWidth(section.columns),
                                }}
                              >
                                <InputFields
                                  field={displayedField}
                                  control={control}
                                  errors={errors}
                                  register={register}
                                  isSmall={true}
                                  isPreview={false}
                                  {...fieldConfig}
                                />
                              </Box>
                            ) : null;
                          })}
                        </Box>
                      </Box>
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box
              sx={{
                position: "sticky",
                bottom: 0,
                left: 0,
                right: 0,
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
                backdropFilter: "blur(4px)",
                WebkitBackdropFilter: "blur(4px)",
                borderTop: "1px solid #FFFFFF2E",
                p: "0.5rem 1rem",
                gap: "1rem",
                backgroundColor: "#f7f9fc",
                zIndex: 10,
              }}
            >
              <Button
                variant="outlined"
                size="small"
                onClick={closeDialog}
                sx={{ fontSize: "0.8rem" }}
              >
                Cancel
              </Button>
              <LoadingButton
                // loading={isSubmitting}
                variant="contained"
                size="small"
                type="submit"
                sx={{ fontSize: "0.8rem" }}
              >
                Create Matter
              </LoadingButton>
            </Box>
          </form>
        </Box>
      </Box>
    </Box>
  );
};

export default MatterForm;
